
//const imageurl = "http://api.schoone.de/public/images";
const imageurl = "https://api.evolvejobs.de/schoneboom/api/public/images";
export default imageurl;